import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_SimulationDemoEvent, DBDef_SimulationDemoEvent } from '@app/ehr-emulator-shared';
export const dispatch_onSimulationDemoEventChanged = new ThunderDispatcherV3('__onSimulationDemoEventUpdated');
export class ModuleFE_SimulationDemoEvent_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_SimulationDemoEvent, dispatch_onSimulationDemoEventChanged);
        this._v1 = {
            getEncounterData: apiWithBody(ApiDef_SimulationDemoEvent._v1.getEncounterData),
        };
    }
}
export const ModuleFE_SimulationDemoEvent = new ModuleFE_SimulationDemoEvent_Class();
//# sourceMappingURL=ModuleFE_SimulationDemoEvent.js.map